import { animationKeys } from './animations';
import { displayKeys } from './display';
import { flexboxKeys } from './flexbox';
import { gridKeys } from './grid';
import { heightKeys } from './height';
import { marginKeys } from './margin';
import { overflowKeys } from './overflow';
import { paddingKeys } from './padding';
import { positionKeys } from './position';
import { shadowElevationKeys } from './shadowElevation';
import { textDecorationKeys } from './textDecoration';
import { whiteSpaceKeys } from './whiteSpace';
import { widthKeys } from './width';
const customKeys = [
    ...animationKeys,
    ...displayKeys,
    ...flexboxKeys,
    ...gridKeys,
    ...heightKeys,
    ...marginKeys,
    ...overflowKeys,
    ...paddingKeys,
    ...positionKeys,
    ...shadowElevationKeys,
    ...textDecorationKeys,
    ...whiteSpaceKeys,
    ...widthKeys,
];
function spreadTransientProps(props, customFields = []) {
    return spreadTransientPropsWithCustomPrefix(props, '$', customFields);
}
function spreadTransientPropsWithCustomPrefix(props, prefix, customFields) {
    const transientKeys = [...customKeys, ...customFields];
    const prefixedSourceTuples = Object.entries(props).map(([key, value]) => {
        const propKey = transientKeys.includes(key) ? `${prefix}${key}` : key;
        return [propKey, value];
    });
    return Object.fromEntries(prefixedSourceTuples);
}
export { spreadTransientProps };
